import CreateDomesticFieldReactiveWorkItemModel from "../data/webServiceModels/CreateDomesticFieldReactiveWorkItemModel";
import CreateDomesticCMVWorkItemModel from "../data/webServiceModels/CreateDomesticCMVWorkItemModel";
import CreateDisconnectionWorkItemModel from "../data/webServiceModels/CreateDisconnectionWorkItemModel";
import CreateReconnectionWorkItemModel from "../data/webServiceModels/CreateReconnectionWorkItemModel";
import CreateProjectWorkItemModel from "../data/webServiceModels/CreateProjectWorkItemModel";

const getCreateWorkItemModelByTemplate = (template) => {
  const models = {
    DomesticFieldReactive: CreateDomesticFieldReactiveWorkItemModel,
    DomesticCMV: CreateDomesticCMVWorkItemModel,
    Disconnection: CreateDisconnectionWorkItemModel,
    Reconnection: CreateReconnectionWorkItemModel,
  };
  return models[template] || CreateProjectWorkItemModel;
};

export default getCreateWorkItemModelByTemplate;
